export default __webpack_public_path__ + "a1bde3b0f2ab66dbaadf4b014407be79.svg";